module.exports = __webpack_public_path__ + "media/icons/pierwsza-rejestracja@3x-d74dc4a4.svg";